Ext.define('SA.view.legend.MapCenter', {
    alias: 'widget.legend-map-center',
    extend: 'Ext.Component',

    cls: 'sa-legend-map-center',
    overCls: 'sa-legend-map-center-over',

    tpl: [
        '<div class="sa-legend-map-center-label">{label}</div>',
        '<div>{name:htmlEncode}</div>'
    ],

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClick, this);
    },

    onClick() {
        var menu = this.lastMenu,
            legend = this.up('map-legend'),
            groupId = this.getId() + '-unit-group',
            items;

        if (legend.isDrag) {
            return;
        }

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        legend.addCls('sa-legend-active');

        items = [{
            checked: legend.mapCenterUnit === 'auto',
            group: groupId,
            text: 'Same as Map',
            xtype: 'menucheckitem',

            handler() {
                legend.mapCenterUnit = 'auto';
                legend.refresh();
            }
        }];

        legend.getGeographicUnits().forEach(unit => {
            items.push({
                checked: legend.mapCenterUnit === unit.id,
                group: groupId,
                text: unit.singularName,
                xtype: 'menucheckitem',

                handler() {
                    legend.mapCenterUnit = unit.id;
                    legend.refresh();
                }
            });
        });

        menu = this.lastMenu = Ext.widget({
            xtype: 'arrow-menu',

            alignment: 'left/right',
            items,
            target: this,
            track: true,

            listeners: {
                destroy() {
                    legend.removeCls('sa-legend-active');
                }
            }
        });
    }
});